export default __webpack_public_path__ + "static/scroll-down-0aaef715650ca287cfe94f463eb197c1.gif";